import { Link } from "@StarberryUtils";
import React from "react";
import {Col, Row, Container } from 'react-bootstrap';
import ServiceCard from "../services/serviceCard/serviceCard"
import  "../services/services.scss";
import ReactMarkdown from "react-markdown"
// //import ScrollAnimation from 'react-animate-on-scroll';

import { GetURL } from "../../common/site/functions";

// import { motion } from "framer-motion";
// import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40 
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}


const Services = (props)=> {

    // useEffect(() => {
    //   console.log("useEffecttt");
    //   function isInViewport (el) {
  
    //     // // Special bonus for those using jQuery
    //     // if (typeof jQuery === "function" && el instanceof jQuery) {
    //     //     el = el[0];
    //     // }
    
    //     var rect = el.getBoundingClientRect();
    
    //     return (
    //         rect.top >= 0 &&
    //         rect.left >= 0 &&
    //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    //         rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    //     );
    // }
    //   function isInViewportx(el) {
    //     let top = el.offsetTop;
    //     let left = el.offsetLeft;
    //     let width = el.offsetWidth;
    //     let height = el.offsetHeight;
  
    //     while (el.offsetParent) {
    //       el = el.offsetParent;
    //       top += el.offsetTop;
    //       left += el.offsetLeft;
    //     }
  
    //     return (
    //       top < (window.pageYOffset + window.innerHeight) &&
    //       left < (window.pageXOffset + window.innerWidth) &&
    //       (top + height) > window.pageYOffset &&
    //       (left + width) > window.pageXOffset
    //     );
    //   }
  
    //   const box = document.querySelector('.textc');
    //   const img = document.querySelector('.imgx');
    //   const text = document.querySelector('.textCont');
    //   console.log("classes",box,img,text);
  
    //   window.addEventListener('scroll', handleScroll, true);
    //   //  {
    //   //   passive: true
    //   // });
    //   // document.addEventListener('scroll',()=>{ console.log("scroll")})
  
    //   function handleScroll() {
  
    //     console.log("classes",box,img,text,isInViewport(img));  
    //     if (isInViewport(img)) {
    //       console.log('slide image');
  
    //       /** Here one can write animate.css class for animation **/
    //       img.classList.add('animate__fadeInLeft', 'animate__slower');
  
    //     } else {
    //       img.classList.remove('animate__fadeInLeft', 'animate__slower');
  
    //     }
  
    //     if (isInViewport(text)) {
    //       /** Here one can write animate.css class for animation **/
    //       text.classList.add('animate__fadeInRight', 'animate__slower');
  
    //     } else {
    //       text.classList.remove('animate__fadeInRight', 'animate__slower');
  
    //     }
  
  
    //   //   if (isInViewport(box)) {
  
    //   //     /** Here one can write animate.css class for animation **/
    //   //     box.classList.add('animate__fadeInUp', 'animate__slower');
  
    //   //   } else {
  
    //   //     box.classList.remove('animate__fadeInUp', 'animate__slower');
  
    //   //   }
    //   }
  
    //   return () => {
    //     document.addEventListener('scroll', handleScroll);
    //   }
  
    // }, [])
    
    let cta_url = ''
    if(props.Service_CTA_Link !== null) {
        cta_url = GetURL(props.Service_CTA_Link.id)
    }
    let cta_url_two = ''
    if(props.Service_CTA_Link_Two !== null) {
      cta_url_two = GetURL(props.Service_CTA_Link_Two.id)
    }

  return(
    <>
          <section
            className="services-sec components-Home-services-services"
          >
            <Container>
              <Row className="align-items-center"> 
                <Col lg={8}>
                  <div variants={titleVariants}>
                      <div className="service-details text-center text-md-left">
                          <ReactMarkdown source={props.Service_Content} allowDangerousHtml />
                          {props.Service_CTA_Label ?
                          <Link className="btn" to={`/${cta_url}`}>{props.Service_CTA_Label}</Link> : '' }
                          {props.Service_CTA_Label_Two ?
                          <Link className="btn home-find-a-home" to={`/${cta_url_two}`}>{props.Service_CTA_Label_Two}</Link> : '' }
                      </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <ServiceCard
                    Links={props.Services}
                  />
                </Col>
              </Row>
            </Container>
          </section>
      </>
  )
}

export default Services
